import { render, staticRenderFns } from "./HomeHotDeals.vue?vue&type=template&id=6c4c9f71&scoped=true&"
import script from "./HomeHotDeals.vue?vue&type=script&lang=js&"
export * from "./HomeHotDeals.vue?vue&type=script&lang=js&"
import style0 from "./HomeHotDeals.vue?vue&type=style&index=0&id=6c4c9f71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4c9f71",
  null
  
)

export default component.exports